import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Megaphone } from "lucide-react";
import { cn } from "@/lib/utils";

export const ShopWerbungTabs = () => {
  const { pathname } = useLocation();
  const tabs = [
    { to: "/shop", label: "Shop", icon: ShoppingBag, active: pathname.startsWith("/shop"), testid: "shop-werbung-tab-shop" },
    { to: "/werbematerial", label: "Werbematerial", icon: Megaphone, active: pathname.startsWith("/werbematerial"), testid: "shop-werbung-tab-werbematerial" },
  ];
  return (
    <div className="inline-flex rounded-full border border-zinc-200 bg-white p-1 shadow-sm" data-testid="shop-werbung-tabs">
      {tabs.map((t) => (
        <Link
          key={t.to}
          to={t.to}
          data-testid={t.testid}
          className={cn(
            "inline-flex items-center gap-1.5 px-4 h-9 rounded-full text-sm font-semibold transition-colors",
            t.active ? "brand-gradient-bg text-white shadow-sm" : "text-zinc-600 hover:text-zinc-900"
          )}
        >
          <t.icon className="h-4 w-4" /> {t.label}
        </Link>
      ))}
    </div>
  );
};
